import React from 'react';
import { Provider } from 'react-redux';
import ConfigStore from './store/ConfigStore';
const store = ConfigStore();
import Payments from './views/Payments';
import { hot } from 'react-hot-loader';

const Root = () => (
  <Provider store={store}>
    <Payments />
  </Provider>
);

export default hot(module)(Root);



// WEBPACK FOOTER //
// ./src/payments/root.js